/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useTranslation } from "react-i18next";
import { COLORS } from "./footer.constants";

export default function FooterLinks({ scrollToSection, onOpenLegalDoc }) {
  const { t, i18n } = useTranslation();
  const isAR = i18n.language === "ar";

  const links = [
    { id: "about-section", label: t("footer.about") },
    { id: "plans-section", label: t("footer.pricing") },
    { id: "support", label: t("footer.support") },
  ];

  return (
    <div className="col-12 col-md-4 mb-4 d-flex flex-column align-items-center">
      <h5
        className="fw-bold mb-3"
        style={{
          color: COLORS.gold,
          fontFamily: "'Cairo', sans-serif",
        }}
      >
        {t("footer.linksTitle")}
      </h5>

      <ul
        className="mb-0"
        style={{
          lineHeight: 1.9,
          padding: 0,
          listStyle: "none",
        }}
      >
        {links.map((link, idx) => (
          <li
            key={idx}
            style={{
              marginBottom: "6px",
              cursor: "pointer",
              color: COLORS.textLight,
              transition: "all 0.3s ease",
            }}
            onClick={() => scrollToSection(link.id)}
            onMouseEnter={(e) => (e.currentTarget.style.color = COLORS.gold)}
            onMouseLeave={(e) =>
              (e.currentTarget.style.color = COLORS.textLight)
            }
          >
            {link.label}
          </li>
        ))}
      </ul>

      <div style={{ marginTop: "12px", textAlign: "center" }}>
        <span
          onClick={() => onOpenLegalDoc("terms")}
          style={{
            color: COLORS.textLight,
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          {isAR ? "الشروط والأحكام" : "Terms and Conditions"}
        </span>
        <span style={{ margin: "0 8px", color: COLORS.textLight }}>|</span>
        <span
          onClick={() => onOpenLegalDoc("privacy")}
          style={{
            color: COLORS.textLight,
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          {isAR ? "سياسة الخصوصية" : "Privacy Policy"}
        </span>
      </div>
    </div>
  );
}
